module.exports = __webpack_public_path__ + "img/wk1.4dcbfb02.jpg";